import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Classes from "./DropDown.module.css";
import { ArrowDownIcon } from "../../../../../../../utils/Icons";

export default function DropDown({
  selectedValue,
  options = [],
  onChange,
  isDropDown = true,
}) {
  const [dropDown, setDropDown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className={Classes.dropDown}>
      {/* Dropdown Head */}
      <div
        className={`${Classes.dropDownHead} 
        ${selectedValue === 'On the way' ? 'on_the_way' : selectedValue}`} //Adding relaveant colors class to the dropdown head
        onClick={() => isDropDown && setDropDown(!dropDown)}
        style={{
          cursor: isDropDown ? "pointer" : "default",
        }}
      >
        <p style={{ textTransform: "capitalize" }} className={selectedValue === 'On the way' ? 'on_the_way' : selectedValue} >
          {selectedValue ? selectedValue : "--"}
        </p>
        {isDropDown && (
          <>
            <ArrowDownIcon
              height='10px'
              fill={selectedValue === "Completed" ? '#008c4b' : selectedValue === "Upcoming" ? '#0052ff' : selectedValue === "Cancelled" ? '#ff0000' : selectedValue === 'On the way' ? '#ff8800' : selectedValue === 'Delayed' ? '#cdd000' : `#000000`}
            // style={{ transform: dropDown ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s ease" }}
            />
          </>
        )}
      </div>

      {/* Dropdown Body */}
      {/* <AnimatePresence>
        {dropDown && isDropDown && (
          <motion.div
            initial={{ opacity: 0, y: -5 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -5 }}
            transition={{ duration: 0.15 }}
            className={Classes.dropDownBody}
          >
            <div className={Classes.ddPointerCon}>
              <div className={Classes.dropDownPointer}></div>
            </div>
            <div className={Classes.dropDownBodyInner}>
              {options.map((option, index) => (
                <div key={index}>
                  <div
                    className={`${Classes.dropDownElem} ${selectedValue === option ? Classes.activeDropElem : ""}`}
                    onClick={() => {
                      onChange(option);
                      setDropDown(false);
                    }}
                    style={{ padding: "5px 10px" }}
                  >
                    <h5>{option}</h5>
                  </div>
                  {index < options.length - 1 && <div className={Classes.dropDownLine}></div>}
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence> */}

      {/* Hidden input for form control */}
      <input type="hidden" value={selectedValue} readOnly />
    </div>
  );
}
